module.exports = __webpack_public_path__ + "static/media/insights-items.392a1310.png";